/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './dental-tooth.reducer';

export const DentalToothDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const dentalToothEntity = useAppSelector(state => state.dentalTooth.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="dentalToothDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.dentalTooth.detail.title">DentalTooth</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.id">Id</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.id}</dd>
          <dt>
            <span id="toothNumber">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.toothNumber">Tooth Number</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.toothNumber}</dd>
          <dt>
            <span id="localization">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.localization">Localization</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.localization}</dd>
          <dt>
            <span id="locale">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.locale">Locale</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.locale}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.active">Active</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.dentalTooth.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{dentalToothEntity.timestampentry}</dd>
        </dl>
        <Button tag={Link} to="/dental-tooth" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/dental-tooth/${dentalToothEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DentalToothDetail;
